import { geocodeByAddress } from 'react-places-autocomplete';
import post from './fetchservice';
import { db, geoFire, firebase } from './firebase';
import { verifyLogin, verifyRegister, verifyUsersettings, verifyPet, verifyRequest } from './validation';
import {
  IS_AUTH,
  LOGIN_CHANGE,
  PETS_LOAD,
  ADD_SEARCHRESULT,
  PET_CHANGE,
  PET_SELECTED,
  PET_DROPFILES,
  NOT_LOGGED_IN,
  GET_USER,
  UPDATE_REQUEST,
  SHOW_SEARCH_RESULTS,
  LOAD_USER_COMMENT,
  REGISTER_CHANGE,
  CURRENT_USER_LOADED,
  SEARCHQUERY_CHANGE,
  USER_DROPFILE,
  USERSETTINGS_CHANGE,
  ORDER_RESULT,
  REQUEST_CHANGE,
  GET_RATINGS,
  CHECKED_CAN_ADD_RATING,
  LOAD_USER,
  REQUEST_LOADED,
  GET_MESSAGES,
  PRELOAD_REQUEST,
  ADD_MESSAGE,
  REQUEST_CHECKBOX_CHANGE,
  MESSAGE_CHANGE,
  REQUEST_PET_LOADED,
  RATING_CHANGE,
  ERROR_HANDLER,
  USER_LOGGED_IN,
  INFO_HANDLER,
  RESET_ALERT
} from '../actions';


const auth = () => {
  const user = firebase.auth();
  return user;
};

const currentUser = () => {
  const user = auth().currentUser;
  return user;
};
const getUidOrFalse = () => {
  const user = currentUser();
  return user && user.uid;
};

const cleanObject = object => {
  if (object) {
    delete object[''];
    const propNames = Object.getOwnPropertyNames(object);
    for (let i = 0; i < propNames.length; i += 1) {
      const propName = propNames[i];
      if (object[propName] === null || object[propName] === undefined) {
        delete object[propName];
      }
    }
  }
  return object;
};

const removeUserInfos = object => {
  delete object.email;
  delete object.password;
  return object;
};

const getLocation = address =>
  geocodeByAddress(address).then(results => {
    if (results && results.length !== 0 && results[0].geometry) {
      const { lat, lng } =
        results &&
        results.length !== 0 &&
        results[0].geometry &&
        results[0].geometry.location;
      return [lat(), lng()];
    }
    throw new Error('Ungültige Location!');
  });

export const orderByChange = (criterium, direction) => dispatch =>
  dispatch({ type: ORDER_RESULT, criterium, direction });

export const resetAlerts = () => dispatch => dispatch({ type: RESET_ALERT });

export const getPets = (uid = getUidOrFalse()) => dispatch => {
  db
    .collection('pet')
    .where('userId', '==', uid)
    .get()
    .then(querySnapshot =>
      dispatch({ type: PETS_LOAD, response: querySnapshot.docs }))
    .catch(() =>
      dispatch({
        type: ERROR_HANDLER,
        errorMessage: 'Fehler beim laden der Haustiere.'
      }));
};

export const register = (registerVm, history) => dispatch => {
  verifyRegister(registerVm)
    .then(({ email, password }) =>
      auth()
        .createUserWithEmailAndPassword(email, password)
        .then(user => {
          if (user) {
            return user.sendEmailVerification();
          }
          throw new Error('user bereits vorhanden');
        })
        .then(() => history.push('/confirm'))
        .catch(() => {
          dispatch({
            type: ERROR_HANDLER,
            errorMessage:
        'Fehler bei der Registrierung. E-Mail bereits registriert.'
          });
        }))
    .catch(({ message }) => dispatch({ type: ERROR_HANDLER, errorMessage: message }));
};

export const updateUsersettings = usersettingsVm => dispatch => {
  verifyUsersettings(usersettingsVm)
    .then(() =>
      currentUser()
        .updateProfile(cleanObject(usersettingsVm))
        .then(() =>
          db.doc(`user/${getUidOrFalse()}`)
            .set(cleanObject(removeUserInfos({ ...usersettingsVm, profileIsValid: true })))
            .then(() =>
              usersettingsVm.place &&
            getLocation(usersettingsVm.place)
              .then(location => geoFire.set(getUidOrFalse(), location))
              .then(() => {
                dispatch({
                  type: INFO_HANDLER,
                  infoMessage: 'Profil erfolgreich angepasst.'
                });
                dispatch({
                  type: USERSETTINGS_CHANGE,
                  name: 'profileIsValid',
                  value: true
                });
              })))
        .catch(error => {
          dispatch({
            type: ERROR_HANDLER,
            errorMessage: 'Fehler beim anpassen des Profils.'
          });
          console.log(error);
        }))
    .catch(({ message }) => dispatch({ type: ERROR_HANDLER, errorMessage: message }));
};


export const login = (loginVm, emailVerify) => dispatch =>
  verifyLogin(loginVm, emailVerify)
    .then(() =>
      auth()
        .signInWithEmailAndPassword(loginVm.email, loginVm.password)
        .then(user => dispatch({ type: IS_AUTH, user }))
        .catch(() =>
          dispatch({
            type: ERROR_HANDLER,
            errorMessage: 'E-Mail oder Passwort falsch.'
          })))
    .catch(({ message }) =>
      dispatch({ type: ERROR_HANDLER, errorMessage: message }));

export const confirm = (actionCode, history) => dispatch =>
  auth()
    .applyActionCode(actionCode)
    .then(() => history.push('/'))
    .catch(() =>
      dispatch({
        type: ERROR_HANDLER,
        errorMessage: 'E-Mail oder Passwort falsch.'
      }));

export const logout = () => dispatch =>
  auth()
    .signOut()
    .then(user => dispatch({ type: IS_AUTH, user }))
    .catch(() =>
      dispatch({ type: ERROR_HANDLER, errorMessage: 'Fehler beim logout.' }));

export const getUser = () => dispatch => {
  db
    .doc(`user/${getUidOrFalse()}`)
    .get()
    .then(response =>
      dispatch({
        type: CURRENT_USER_LOADED,
        response: response.data()
      }))
    .catch(() => {
      dispatch({
        type: ERROR_HANDLER,
        errorMessage: 'Benutzer konnte nicht geladen werden.'
      });
    });
};

export const showProfile = uid => dispatch => {
  db
    .doc(`user/${uid}`)
    .get()
    .then(response =>
      dispatch({ type: GET_USER, response: response.data(), uid }))
    .catch(() => {
      dispatch({
        type: ERROR_HANDLER,
        errorMessage: 'Fehler beim laden des Profils.'
      });
    });

  dispatch(getPets(uid));

  db
    .collection('rating')
    .where('toUid', '==', uid)
    .get()
    .then(snapShot => {
      const ratings = new Map(snapShot.docs.map(x => {
        const { fromUid, ...rest } = x.data();
        return [fromUid, rest];
      }));

      Array.from(ratings.keys()).forEach(key => {
        db
          .doc(`user/${key}`)
          .get()
          .then(x =>
            dispatch({ type: LOAD_USER_COMMENT, user: x.data(), key }));
      });

      dispatch({ type: GET_RATINGS, ratings });
    });

  db
    .collection('request')
    .where('fromUid', '==', getUidOrFalse())
    .where('toUid', '==', uid)
    .get()
    .then(snapShot => {
      dispatch({ type: CHECKED_CAN_ADD_RATING, response: snapShot.docs });
    })
    .catch(() =>
      dispatch({
        type: ERROR_HANDLER,
        errorMessage: 'Fehler beim laden des Profils.'
      }));
};

export const loadRequestData = requestSnapshot => dispatch => {
  const requestMap = new Map(requestSnapshot.docs.map(x => [x.id, x.data()]));
  dispatch({
    type: PRELOAD_REQUEST,
    requestMap
  });
  Array.from(requestMap.keys()).forEach(key => {
    db
      .doc(`request/${key}`)
      .get()
      .then(response => {
        const responseData = response.data();
        const { pets2Pate, fromUid, toUid } = responseData;

        pets2Pate.forEach(petKey => {
          db
            .doc(`pet/${petKey}`)
            .get()
            .then(x =>
              dispatch({
                type: REQUEST_PET_LOADED,
                response: x.data(),
                key: x.id
              }));
        });
        const conversationPartner =
          fromUid === getUidOrFalse() ? toUid : fromUid;

        db
          .doc(`user/${conversationPartner}`)
          .get()
          .then(x =>
            dispatch({ type: LOAD_USER, response: x.data(), key: x.id }));

        dispatch({ type: REQUEST_LOADED, response: responseData, key });
      });
  });
};

export const getAllRequests = () => dispatch => {
  db
    .collection('request')
    .where('fromUid', '==', getUidOrFalse())
    .get()
    .then(snapShot => {
      dispatch(loadRequestData(snapShot));
    });
  db
    .collection('request')
    .where('toUid', '==', getUidOrFalse())
    .get()
    .then(snapShot => {
      dispatch(loadRequestData(snapShot));
    });
};

export const getMessages = () => dispatch => {
  db
    .collection('message')
    .where('fromUid', '==', getUidOrFalse())
    .get()
    .then(messagesFrom =>
      db
        .collection('message')
        .where('toUid', '==', getUidOrFalse())
        .get()
        .then(messagesTo => {
          dispatch({
            type: GET_MESSAGES,
            messagesFrom: messagesFrom.docs,
            messagesTo: messagesTo.docs
          });
        }));
};

export const isAuthorized = () => dispatch =>
  auth().onAuthStateChanged(user => {
    if (user) {
      dispatch({ type: USER_LOGGED_IN, response: user });
    } else {
      dispatch({ type: NOT_LOGGED_IN, user });
    }
  });

export const addPet = (petVm, history) => dispatch =>
  verifyPet(petVm)
    .then(pet => db
      .collection('pet')
      .add({ ...cleanObject(pet), userId: getUidOrFalse() })
      .then(() => history.push('/pets'))
      .catch(() =>
        dispatch({
          type: ERROR_HANDLER,
          errorMessage: 'Fehler beim hinzufügen eines Pets.'
        })))
    .catch(errorMessage => dispatch({
      type: ERROR_HANDLER,
      errorMessage: errorMessage.message
    }));

export const createRating = (requestUid, toUid, vm) => dispatch => {
  db
    .doc(`rating/${requestUid}`)
    .set({ toUid, fromUid: getUidOrFalse(), ...vm })
    .then(() => {
      dispatch({
        type: INFO_HANDLER,
        infoMessage: 'Bewertung erfolgreich erstellt.'
      });
    })
    .catch(() =>
      dispatch({
        type: ERROR_HANDLER,
        errorMessage: 'Fehler beim erstellen der Bewertung.'
      }));
};

export const acceptPateEntry = key => dispatch =>
  db
    .doc(`request/${key}`)
    .set({ accepted: true }, { merge: true })
    .then(() =>
      dispatch({ type: UPDATE_REQUEST, response: { accepted: true }, key }))
    .catch(() =>
      dispatch({
        type: ERROR_HANDLER,
        errorMessage: 'Fehler beim akzeptieren der Anfrage.'
      }));

export const replySubmit = (requestUid, toUid, message) => dispatch => {
  const newMessage = {
    fromUid: getUidOrFalse(),
    message,
    date: new Date(),
    requestUid,
    toUid
  };
  db
    .collection('message')
    .add(newMessage)
    .then(msg =>
      dispatch({ type: ADD_MESSAGE, newMessage: { ...newMessage, id: msg.id } }))
    .catch(() =>
      dispatch({
        type: ERROR_HANDLER,
        errorMessage: 'Fehler beim Senden der Nachricht.'
      }));
};

export const pateRequest = (requestVm, toUid) => dispatch => {
  verifyRequest(requestVm)
    .then(() => db
      .collection('request')
      .add({
        fromUid: getUidOrFalse(),
        toUid,
        ...requestVm,
        accepted: false
      })
      .then(request => {
        db
          .collection('message')
          .add({
            fromUid: getUidOrFalse(),
            message: requestVm.message,
            date: new Date(),
            toUid,
            requestUid: request.id
          })
          .then(() =>
            dispatch({
              type: INFO_HANDLER,
              infoMessage: 'Anfrage erfolgreich erstellt.'
            }))
          .catch(() =>
            dispatch({
              type: ERROR_HANDLER,
              errorMessage: 'Fehler beim erstellen der Anfrage.'
            }));
      })
      .catch(() =>
        dispatch({
          type: ERROR_HANDLER,
          errorMessage: 'Fehler beim erstellen der Anfrage.'
        })))
    .catch(error =>
      dispatch({
        type: ERROR_HANDLER,
        errorMessage: error.message
      }));
};

export const getPet = uid => dispatch =>
  db
    .doc(`pet/${uid}`)
    .get()
    .then(response => dispatch({ type: PET_SELECTED, response }))
    .catch(error => {
      console.log(error);
      dispatch({
        type: ERROR_HANDLER,
        errorMessage: 'Fehler beim laden des Pets.'
      });
    });

export const updatePet = (petVm, history) => dispatch =>
  verifyPet(petVm)
    .then(pet => db
      .doc(`pet/${pet.id}`)
      .set(cleanObject(pet))
      .then(() => history.push('/pets'))
      .catch(() =>
        dispatch({
          type: ERROR_HANDLER,
          errorMessage: 'Fehler beim aktualisieren des Pets.'
        })))
    .catch(errorMessage => dispatch({
      type: ERROR_HANDLER,
      errorMessage: errorMessage.message
    }));

export const search = radius => dispatch => {
  geoFire.get(getUidOrFalse()).then(location => {
    const query = geoFire.query({ center: location, radius });
    query.on('key_entered', (key, x, distance) => {
      db
        .doc(`user/${key}`)
        .get()
        .then(response =>
          dispatch({
            type: ADD_SEARCHRESULT,
            response,
            distance,
            key
          }));
    });

    query.on('ready', () => {
      dispatch({
        type: SHOW_SEARCH_RESULTS
      });
    });
  });
};

export const loginChange = (name, value) => ({
  type: LOGIN_CHANGE,
  value,
  name
});

export const ratingChange = (name, value) => ({
  type: RATING_CHANGE,
  name,
  value
});

export const changePet = (name, value) => ({ type: PET_CHANGE, name, value });

export const dropfiles = acceptedFiles => dispatch => {
  const reader = new FileReader();
  reader.onload = ({ currentTarget }) =>
    post('https://api.cloudinary.com/v1_1/dbpnzmimp/image/upload', {
      upload_preset: 'wdrkp8go',
      file: currentTarget.result
    }).then(response => {
      dispatch({
        type: PET_DROPFILES,
        secureUrl: response.secure_url
      });
    });
  reader.readAsDataURL(acceptedFiles[0]);
};

export const dropUserimage = acceptedFiles => dispatch => {
  const reader = new FileReader();
  reader.onload = ({ currentTarget }) =>
    post('https://api.cloudinary.com/v1_1/dbpnzmimp/image/upload', {
      upload_preset: 'wdrkp8go',
      file: currentTarget.result
    }).then(response => {
      dispatch({
        type: USER_DROPFILE,
        secureUrl: response.secure_url
      });
    });
  reader.readAsDataURL(acceptedFiles[0]);
};

export const selectPet = pet => ({ type: PET_SELECTED, pet });

export const registerChange = (name, value) => ({
  type: REGISTER_CHANGE,
  name,
  value
});
export const requestChange = (name, value) => ({
  type: REQUEST_CHANGE,
  name,
  value
});
export const requestCheckboxChange = (name, index, dependsOn) => ({
  type: REQUEST_CHECKBOX_CHANGE,
  name,
  index,
  dependsOn
});

export const searchQueryChange = (name, value) => ({
  type: SEARCHQUERY_CHANGE,
  name,
  value
});

export const userSettingsChange = (name, value) => ({
  type: USERSETTINGS_CHANGE,
  name,
  value
});

export const replyChange = (name, value) => ({
  type: MESSAGE_CHANGE,
  name,
  value
});



// WEBPACK FOOTER //
// ./src/actions/actions.js